/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Careers_Pay_Per_HourInputs */



/**
* | output |
* | --- |
* | "{amount} per hour" |
*
* @param {Careers_Pay_Per_HourInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const careers_pay_per_hour = /** @type {((inputs: Careers_Pay_Per_HourInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Pay_Per_HourInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`每小时 ${i?.amount}`)
	return /** @type {LocalizedString} */ (`${i?.amount} per hour`)
});